import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BatteryWarningIcon, BrainIcon, FlameIcon } from 'lucide-react';
export function PainSection() {
  return <section className="py-24 px-4 bg-[#111827] relative border-t border-[#c9a84c]/10" data-id="element-254">
      <div className="max-w-4xl mx-auto" data-id="element-255">
        <FadeIn data-id="element-256">
          <p className="text-xl md:text-2xl text-[#f5f5f5] leading-relaxed mb-12 font-medium" data-id="element-257">
            ¿Te has despertado últimamente sintiendo que tu cuerpo pesa una
            tonelada, a pesar de haber dormido 8 horas? Te miras al espejo y ves
            una versión de ti que no reconoces: la "barriga cervecera" que no se
            va, la mirada apagada y esa extraña neblina mental que te hace
            perder el hilo en las reuniones de trabajo. No eres tú. No es "la
            edad". Es tu sistema hormonal pidiendo auxilio tras años de estrés,
            mala alimentación y falta de los nutrientes clave que un hombre de
            tu edad necesita.
          </p>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-258">
          <h2 className="text-3xl md:text-4xl font-bold text-[#c9a84c] mb-8 text-center" data-id="element-259">
            Seamos honestos: el mundo de hoy es una trampa para la testosterona.
          </h2>
          <p className="text-lg text-[#9ca3af] mb-10 text-center max-w-3xl mx-auto" data-id="element-260">
            Tu jefe te exige más, el tráfico de la ciudad te dispara el cortisol
            y la comida que compras en el súper está llena de químicos que
            mimetizan el estrógeno. Si tienes más de 40 años, probablemente has
            notado que:
          </p>
        </FadeIn>

        <div className="space-y-6 mb-12" data-id="element-261">
          <FadeIn delay={0.2} data-id="element-262">
            <div className="bg-[#0a0e1a] border border-[#c9a84c]/20 p-6 rounded-xl flex gap-6 items-start hover:border-[#c9a84c]/50 transition-colors" data-id="element-263">
              <div className="bg-[#111827] p-3 rounded-lg text-[#dc2626] shrink-0" data-id="element-264">
                <BatteryWarningIcon className="w-8 h-8" data-id="element-265" />
              </div>
              <div data-id="element-266">
                <p className="text-lg text-[#f5f5f5]" data-id="element-267">
                  <strong className="text-[#c9a84c]" data-id="element-268">
                    Tu energía se desploma
                  </strong>{' '}
                  a las 3:00 PM y dependes del cuarto café para terminar el día.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-269">
            <div className="bg-[#0a0e1a] border border-[#c9a84c]/20 p-6 rounded-xl flex gap-6 items-start hover:border-[#c9a84c]/50 transition-colors" data-id="element-270">
              <div className="bg-[#111827] p-3 rounded-lg text-[#dc2626] shrink-0" data-id="element-271">
                <BrainIcon className="w-8 h-8" data-id="element-272" />
              </div>
              <div data-id="element-273">
                <p className="text-lg text-[#f5f5f5]" data-id="element-274">
                  <strong className="text-[#c9a84c]" data-id="element-275">
                    Ir al gimnasio se siente como una tortura
                  </strong>{' '}
                  y los resultados son nulos porque tu metabolismo está dormido.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-276">
            <div className="bg-[#0a0e1a] border border-[#c9a84c]/20 p-6 rounded-xl flex gap-6 items-start hover:border-[#c9a84c]/50 transition-colors" data-id="element-277">
              <div className="bg-[#111827] p-3 rounded-lg text-[#dc2626] shrink-0" data-id="element-278">
                <FlameIcon className="w-8 h-8" data-id="element-279" />
              </div>
              <div data-id="element-280">
                <p className="text-lg text-[#f5f5f5]" data-id="element-281">
                  <strong className="text-[#c9a84c]" data-id="element-282">
                    La chispa en tu relación se está apagando
                  </strong>{' '}
                  porque tu deseo sexual simplemente no es el que solía ser.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.5} data-id="element-283">
          <div className="bg-gradient-to-r from-[#dc2626]/10 to-transparent border-l-4 border-[#dc2626] p-6 rounded-r-xl" data-id="element-284">
            <p className="text-xl text-[#f5f5f5] font-semibold" data-id="element-285">
              Lo peor es que los médicos te dicen que "es normal por la edad".{' '}
              <span className="text-[#dc2626]" data-id="element-286">Mienten.</span> No es normal
              vivir agotado. No es normal aceptar el declive cuando apenas estás
              en el mejor momento de tu carrera y tu vida familiar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}